// Backend URL configuration
// -------------------------
// Production MUST go through the Railway-hosted backend connected to the
// user's own MongoDB Atlas cluster. Emergent's deployment pipeline injects
// its own REACT_APP_BACKEND_URL pointing at an Emergent-managed backend,
// which bypasses the real production data — so we pin production hosts
// explicitly here.
//
// Any of these public hosts routes to Railway:
//   - duolyst.co.uk         (custom domain — currently degraded due to
//                            the July TLS cert expiry, kept for future
//                            recovery once the cert is re-issued)
//   - trip-memo.emergent.host (current live URL after the July 2026
//                              redeploy — Emergent auto-provisioned this
//                              hostname when the custom domain lapsed)
//
// Preview / dev / staging continue to use whatever the build-time env var
// says (typically the Emergent preview URL).
const PRODUCTION_HOSTS = new Set([
  "duolyst.co.uk",
  "trip-memo.emergent.host",
]);
const RAILWAY_BACKEND_URL = "https://duolyst-app-backend-production.up.railway.app";

const _isProductionHost =
  typeof window !== "undefined" &&
  window.location &&
  PRODUCTION_HOSTS.has(window.location.hostname);

export const BACKEND_URL = _isProductionHost
  ? RAILWAY_BACKEND_URL
  : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
